<template>
    <b-navbar class="floating-navbar">
      <b-container-fluid style="width: 100%">
        <b-row class="justify-content-center">
          <b-col></b-col>
          <b-col cols="auto" class="floating-navbar-content">
            <b-btn pill :variant="!mode ? 'primary': 'text'" @click="resetMode()">
              <font-awesome-icon icon="hand" /> {{ $t("menu.hand") }}
            </b-btn>
            <b-btn 
              pill
              v-b-tooltip.hover.right.v-danger="isScaleSet?'':'Disabled. Set Unit Scale First.'"
              :variant="mode == 'roof' ?'primary': 'text'" 
              :disabled="!isScaleSet"
              @click="setMode('roof')"
            >
              <font-awesome-icon icon="draw-polygon" /> {{ $t("menu.add_roof_section") }}
            </b-btn>
  
            <b-btn 
              pill
              v-b-tooltip.hover.right.v-danger="isScaleSet?'':'Disabled. Set Unit Scale First.'"
              :variant="mode == 'equipment' ? 'primary' : 'text'" 
              :disabled="!isScaleSet"
              @click="openSidebar('equipments')"
            >
              <font-awesome-icon icon="compass-drafting" /> {{ $t("menu.add_equipment") }}
            </b-btn>
            <b-btn 
              v-b-tooltip.hover.right.v-danger="isScaleSet?'':'Disabled. Set Unit Scale First.'"
              variant="text" 
              :disabled="!isScaleSet"
              @click="openSidebar('assets-list')"
            >
              <font-awesome-icon icon="image" /> {{ $t("menu.assets") }}
            </b-btn>
            <b-btn 
              v-if="!isScaleSet || !sections.length"
              v-b-tooltip.hover.right.v-danger="isScaleSet?'':'Disabled. Set Unit Scale First.'"
              :variant="mode == 'unit-scale'? 'primary' : 'text'" 
              @click="setMode('unit-scale')"
            >
              <font-awesome-icon icon="ruler-combined" /> {{ $t("menu.unit_scale") }}
            </b-btn>
            <b-btn 
              v-if="!isScaleSet || !sections.length"
              v-b-tooltip.hover.right.v-danger="isScaleSet?'':'Disabled. Set Unit Scale First.'"
              variant="text" 
              @click="openHelp()"
            >
              <font-awesome-icon icon="info-circle" /> {{ $t("menu.help") }}
            </b-btn>
          </b-col>
          <b-col></b-col>
        </b-row>
      </b-container-fluid>
      
    </b-navbar>
</template>
<style scoped>
h6{
  font-size: 9px
}

</style>
<script>
  import { ProjectMixin } from '@/mixins';
  import { mapGetters } from 'vuex';
  
  export default {
      name: "AppTools",
      mixins:[ProjectMixin],
      data: () => ({
          fav: true,
          menu: true,
          message: false,
          hints: true,
          items: [
              { icon: "mdi-plus", title: "New Project", link: "/projects/new" },
              { icon: "mdi-plus", title: "New Client", link: "/clients/new" },
              { icon: "mdi-factory", title: "New Building", link: "/buildings/new" }
          ],
      }),
      computed: {
        ...mapGetters({
          sections: 'sections/items',
          shape: 'sections/currentShape',
          equipments: "equipments/items",
          mode : 'sections/currentMode',
          isScaleSet: 'projects/isScaleSet'
        }),
      },
      methods:{
        openHelp(){
          this.$store.dispatch('ui/modal', {
            show: true,
            size: 'md',
            component: 'info'
          });
        }
      }
  }
</script>
<style>
  .app-tools .navbar-text:hover{
    cursor: pointer;
    background: #FFFDE7;
  }
</style>
